// CustomerTypePie.tsx
import React from "react";
import { PieChart, Pie, Cell, ResponsiveContainer } from "recharts";
import '../../Customers.scss'
import { formatNumber } from "../../../../services/mixin";
import { IDataDefaulFilter } from "..";
import { useNavigate } from "react-router-dom";


interface props {
    data?: {
        totalCustomer: number;
        totalSingle: number;
        totalMarried: number;
        totalElse: number;
    }
    dataFilter: IDataDefaulFilter 
}

const MARITAL_ITEMS = [
    { key: "totalSingle", name: "Độc thân", color: "#1890FF", type: 0 },
    { key: "totalMarried", name: "Đã kết hôn", color: "#7B61FF", type: 1 },
    { key: "totalElse", name: "Không xác định", color: "#F59C23", type: 2 },
] as const;

export const CustomerTypePie: React.FC<props> = ({ data, dataFilter }) => {
const navigate = useNavigate()

    const total = data?.totalCustomer ?? 0;

    const chartData = MARITAL_ITEMS.map((item) => ({
        name: item.name,
        value: data?.[item.key] ?? 0,
        color: item.color,
        type: item.type
    }));

    return (
        <div className="custom-page-css w-full flex h-full  flex-col justify-between items-center gap-6">
            <div className="custom-page-css w-240px h-240px">
                <ResponsiveContainer>
                    <PieChart>
                        <Pie
                            data={chartData}
                            dataKey="value"
                            outerRadius={110}
                            paddingAngle={2}
                        >
                            {chartData.map((entry, index) => (
                                <Cell
                                    key={index}
                                    fill={entry.color}
                                    onClick={() => 
                                         navigate(
                                            `/analysis-report/customers-card-list`,
                                            {
                                                state: {
                                                    firstPage: '/analysis-report/marketing-campaigns',
                                                    dataFilterCampaign: dataFilter,
                                                    statusMarital: entry.type,
                                                    title: entry.type === 0 ? `Khách hàng đang độc thân` : entry.type === 1 ? `Khách hàng đã kết hôn` : `Khách hàng không xác định`
                                                }
                                            }
                                        )
                                    }
                                />
                            ))}
                        </Pie>
                    </PieChart>
                </ResponsiveContainer>
            </div>

            {/* Legend */}
            <div className="space-y-2">
                {chartData.map((item) => {
                    const percent =
                        total === 0
                            ? "0"
                            : ((item.value / total) * 100).toFixed(1);
                    return (
                        <div key={item.name} className="flex items-center gap-2 text-sm">
                            <span
                                className="w-3 h-3 rounded-sm"
                                style={{ background: item.color }}
                            />
                            <span>
                                {item.name}: {formatNumber(item.value)} ({percent}%)
                            </span>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};
